import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { runtime } from "../config";

const reactPlugin = new ReactPlugin();
const connectionString = runtime("appInsightsConnectionString") ?? process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;

const appInsights = new ApplicationInsights({
  config: {
    connectionString: connectionString || "",
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
    disableTelemetry: !connectionString,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    correlationHeaderExcludedDomains: ["*.posthog.com"],
  },
});

if (connectionString) {
  appInsights.loadAppInsights();
}

export { appInsights, reactPlugin };
